import { styled } from '@nykaa/ui-components';
import AnimatedLoader from 'components/BelowTheFoldControl/AnimatedLoader';
import { SIZE } from 'constants/strings';

export const Wrapper = styled.div<{
  offerExpState: boolean;
  showDownloadBannerNudge?: boolean;
}>`
  display: flex;
  flex-direction: column;
  background: white;
  ${({ showDownloadBannerNudge }) => showDownloadBannerNudge && 'z-index: 2;'}
  ${({ showDownloadBannerNudge }) =>
    showDownloadBannerNudge && 'position: relative;'}
  ${({ offerExpState, theme: { spacing, borders, elevations } }) => {
    if (offerExpState) {
      return `
        padding: ${spacing.spacing80} ${spacing.spacing80} ${spacing.spacing20} ${spacing.spacing80};
        border-radius: ${borders.radiusNone} ${borders.radiusNone} ${borders.radius40} ${borders.radius40};
        box-shadow: ${elevations.shadow100};
      `;
    } else {
      return `
        padding: ${spacing.spacing0};
      `;
    }
  }}
  a {
    text-decoration: none;
  }
`;

export const CardWrapper = styled.div<{ offerExpState: boolean }>`
  width: 100%;
  display: flex;
  position: relative;
  background: ${({ theme }) => theme.colors.surface};
  margin-bottom: ${({ theme }) => theme.spacing.spacing20};
  ${({ offerExpState, theme: { spacing } }) => {
    if (offerExpState) {
      return '';
    } else {
      return `padding: ${spacing.spacing80} ${spacing.spacing80} ${spacing.spacing0} ${spacing.spacing100};`;
    }
  }}
`;

export const TagsWrapper = styled.div`
  position: relative;
  top: -${({ theme }) => theme.spacing.spacing40};
  left: -${({ theme }) => theme.spacing.spacing40};
`;

export const RatingWrapper = styled.div`
  display: flex;
  width: 90px;
  height: 14px;
  padding: ${({ theme: { spacing } }) =>
    `${spacing.spacing10} ${spacing.spacing20}`};
  align-items: flex-start;
  border-radius: ${({ theme }) => theme.borders.radius20};
  background: ${({ theme }) => theme.colors.surface};
  position: absolute;
  top: 126px;
`;

export const Rating = styled.div`
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.labelSmall};
`;

export const RatingCount = styled.div`
  position: relative;
  color: ${({ theme }) => theme.colors.textSecondary};
  ${({ theme }) => theme.typography.bodyXSmall};
  padding-left: ${({ theme }) => theme.spacing.spacing10};
`;

export const Image = styled.div`
  width: 40%;
  position: relative;
  img {
    width: 132px;
    height: 132px;
  }
  div {
    margin-bottom: ${({ theme }) => theme.spacing.spacing0};
  }
`;

export const Info = styled.div`
  margin-left: ${({ theme }) => theme.spacing.spacing40};
  width: 60%;
  > div {
    margin-bottom: ${({ theme }) => theme.spacing.spacing10};
  }
`;

export const VariantWrapper = styled.div<{ vType: string; isMan: boolean }>`
  background: ${({ theme }) => theme.colors.surface};
  margin-top: ${({ theme }) => theme.spacing.spacing20};
  span:first-child {
    font-weight: inherit;
  }
  div:last-child {
    overflow-x: auto;
    white-space: nowrap;
    flex-wrap: nowrap;
    ${({ vType, theme: { spacing } }) =>
      vType &&
      `
    padding-top: ${
      vType === SIZE
        ? `${spacing.spacing10}`
        : `${spacing.spacing80} ${spacing.spacing0}  ${spacing.spacing40}  ${spacing.spacing20}`
    };
  `}
  }
  button {
    ${({ vType, theme: { spacing } }) =>
      vType &&
      `
    margin: ${
      vType === SIZE
        ? `${spacing.spacing0}`
        : `${spacing.spacing0} ${spacing.spacing40}  ${spacing.spacing0}  ${spacing.spacing0}`
    };

  `}

    > div {
      ${({ vType, theme: { spacing } }) =>
        vType &&
        `
      width: ${vType === SIZE ? 'auto' : '30px'};
      height: ${vType === SIZE ? 'auto' : '30px'};
      font-size: ${vType === SIZE ? '12px' : '14px'};
      padding: ${vType === SIZE ? `${spacing.spacing20}` : 'inherit'};
   `}
    }
    .active:after {
      width: ${({ theme }) => theme.spacing.spacing20};
      height: ${({ theme }) => theme.spacing.spacing40};
      top: ${({ theme }) => theme.spacing.spacing40};
      left: 11px;
    }
    .oos:after {
      width: ${({ theme }) => theme.spacing.spacing100};
      top: 15px;
    }
    .active.oos:after {
      height: 0;
      left: ${({ theme }) => theme.spacing.spacing20};
    }
    .siz_ChipClass {
      width: auto;
      height: auto;
    }
    span {
      ${({ isMan }) => (isMan ? 'display: block;' : 'display: none;')}
    }
    .active {
      ${({ vType }) =>
        vType &&
        `
      font-size: ${vType === SIZE ? '12px' : '14px'};
   `}
    }
  }
`;

export const FewLeft = styled.div`
  color: ${({ theme }) => theme.colors.warning};
  ${({ theme }) => theme.typography.bodySmall};
  margin-top: -${({ theme }) => theme.spacing.spacing20};
`;

export const SoldOut = styled.div`
  color: ${({ theme }) => theme.colors.warning};
  ${({ theme }) => theme.typography.bodySmall};
  margin-top: -${({ theme }) => theme.spacing.spacing20};
`;

export const PrWrapper = styled.div<{ offerExpState: boolean }>`
  ${({ offerExpState, theme: { spacing } }) => {
    if (offerExpState) {
      return '';
    } else {
      return `
        margin-left: ${spacing.spacing80};
        margin-right: ${spacing.spacing80};
      `;
    }
  }}
`;

export const TextNudgeWrapper = styled.div<{
  addMarginBottom: boolean;
  offerExpState: boolean;
}>`
  padding: ${({ theme: { spacing } }) =>
    `${spacing.spacing0} ${spacing.spacing80} ${spacing.spacing0} ${spacing.spacing80}`};
  margin-bottom: ${({ addMarginBottom, theme }) =>
    addMarginBottom && theme.spacing.spacing20};
  ${({ offerExpState, theme }) =>
    offerExpState && `padding: ${theme.spacing.spacing0};`}
`;

export const AddToBagBackgroundWrapper = styled.div`
  padding: ${({ theme: { spacing } }) =>
    `${spacing.spacing60} ${spacing.spacing0} ${spacing.spacing60} ${spacing.spacing0}`};
  background: ${({ theme }) => theme.colors.surface};
  box-shadow: 0px 1px 0px 0px rgba(111, 121, 129, 0.16) inset;
  margin-top: -0.5px;
`;

export const AddToBagBackgroundV2Wrapper = styled.div`
  padding: ${({ theme: { spacing } }) =>
    `${spacing.spacing50} ${spacing.spacing0}`};
  background: ${({ theme }) => theme.colors.surface};
  box-shadow: ${({ theme }) => theme.elevations.shadow100};
  margin-top: -0.5px;
`;

// adding 4px and 8px token spacing is not giving desired result so added 6px.
export const BPWrapper = styled.div`
  margin-bottom: 6px;
`;
export const StripWrapper = styled.div`
  padding-top: ${({ theme }) => `${theme.spacing.spacing60}`};
  background-color: ${({ theme }) => theme.colors.white};
  position: relative;
  z-index: 1;
  margin-top: -18px;
`;
export const Shimmer = styled(AnimatedLoader)`
  padding-right: ${({ theme }) => `${theme.spacing.spacing60} `};
  border-radius: ${({ theme }) => theme.borders.radius30};
  width: 100%;
  height: 63px;
  margin-bottom: ${({ theme: { spacing } }) => `${spacing.spacing40}`};
`;
